<template>
  <app-layout>
    <div class="px-5 md:px-0 confirm-container">
      <div class="nights-comfirmation">
        <div class="sumary-title">
          <h1>{{ $t('shared.reservation_confirmed') }}</h1>
          <p class="mb-5">{{ $t('shared.weve_sent_you_an_email') }}</p>
          <p>{{ $t('card-confirmation.reservation-code') }}: {{reservation.code}}</p>
        </div>
        <div class="img-confirmation mb-12">
          <!-- TODO image dynamic -->
          <img src="/img/card-blog.jpg" class="h-full w-full object-cover"/>
        </div>
        <p class="font-bold mb-2">{{ $t('confirmation_step.travel_to') }} {{ reservation.destinationName }}</p>
        <p>{{ adults }}{{$tc("confirmation_step.traveller", adults)}}</p>
        <div class="pt-6 pb-8 md:pt-8 lg:pt-8">
          <!-- vuelos de ida y vuelta -->
          <div class="confim-card confim-card-body mb-5">
            <div class="travel-container">
              <img src="/img/mails/departure.png" alt="" />
              <h3>
                {{ $t('shared.outbound') }}:
                {{ reservation.outboundTrip.departure.datetime | dayAndDate }}
              </h3>
              <app-flight-info
                class="lg:flex-grow self-stretch"
                :origin="reservation.outboundTrip.departure.airport"
                :destination="reservation.outboundTrip.arrival.airport"
                :departure-time="reservation.outboundTrip.departure.datetime"
                :arrival-time="reservation.outboundTrip.arrival.datetime"
              ></app-flight-info>
            </div>
            <div class="travel-container">
              <img src="/img/mails/arrival.png" alt="" />
              <h3>
                {{ $t('shared.outbound') }}:
                {{ reservation.inboundTrip.departure.datetime | dayAndDate }}
              </h3>
              <app-flight-info
                class="lg:flex-grow self-stretch"
                :origin="reservation.inboundTrip.departure.airport"
                :destination="reservation.inboundTrip.arrival.airport"
                :departure-time="reservation.inboundTrip.departure.datetime"
                :arrival-time="reservation.inboundTrip.arrival.datetime"
              ></app-flight-info>
            </div>
          </div>
          <!-- hotel -->
          <!-- TODO v-for hotels -->
          <hotel-confirmation-card
            v-if="hotel"
            :hotel="hotel"
            :adults="adults"
            :nights="nights"
            :destination="destination"
          >
          </hotel-confirmation-card>

          <div class="md:flex justify-center items-center gap-5 mt-5">
            <div class="confim-card p-5 w-full detail-box">
              <p class="font-bold mb-5">{{ $t('confirmation_step.price_details') }}:</p>
              <div class="flex items-center justify-between">
                <p>Subtotal {{ adults }} {{$tc("confirmation_step.traveller", adults)}}</p>
                <p>{{reservation.payload.bundle_pack | currency}}</p>
              </div>
              <div class="flex items-center justify-between my-2">
                <p>Alojamientos {{ reservation.payload.hotel_category }} x {{ adults }}</p>
                <p v-if="reservation.payload.hotel_category === 'luxury'">{{ extra_hotel_luxury | currency }}</p>
                <p v-else>incluido</p>
              </div>
              <div class="flex items-center justify-between mb-2">
                <p>Seguro {{ premium_insurance ? 'Premium' : 'Básico' }} x {{ adults }}</p>
                <p v-if="premium_insurance">{{ premium_insurance_price | currency }}</p>
                <p v-else>incluido</p>
              </div>
              <div class="flex items-center justify-between font-bold">
                <p>TOTAL</p>
                <p>{{reservation.totalPrice | currency}}</p>
              </div>
            </div>
            <!-- Info payment 60/40 -->
            <div class="confim-card p-5 w-full detail-box detail-box-2">
              <!-- v-if="reservation.destinationCode === 'BAL' || reservation.destinationCode === 'BAL' " -->
              <p class="font-bold mb-5">{{ $t('confirmation_step.payment_details') }}:</p>
              <div class="flex items-center justify-between">
                <p>{{ $t('confirmation_step.you_have_paid_60') }}</p>
                <p class="font-bold">{{ reservation.totalPrice*0.6 | currency }}</p>
              </div>
              <div class="flex baseline justify-between mt-2">
                <p class="w-3/5">{{ $t('confirmation_step.next_payment_40') }}<br> {{ $t('confirmation_step.fifteen_days_before') }}</p>
                <p class="font-bold">{{reservation.totalPrice*0.4 | currency }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <banner-newsletter background="/img/background-image-newsletter.jpg"></banner-newsletter>
  </app-layout>
</template>

<script>
import { mapGetters } from "vuex";
import HotelCategory from "../common/HotelCategory.vue";
import TripadvisorScore from "../accommodation/TripadvisorScore.vue";
import {
  NIGHTS_GET_NIGHTS,
  NIGHTS_GET_PASSENGERS_COUNT,
  GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT,
  NIGHTS_GET_EXTRA_PRICE_TIMES_QUANTITY,
  NIGHTS_GET_BAGS_SUMMARY_INFO,
} from "../../../store/nights/getter-types";
import { GET_RESERVATION } from "../../../store/booking/getter-types";
import moment from "../../../plugins/moment";
import { round } from "../../../pages/nights/helpers";
import HotelCard from "../accommodation/HotelCard.vue";
import BannerNewsletter from '../../../components/BannerNewsletter/BannerNewsletter';
import HotelConfirmationCard from '../accommodation/HotelConfirmationCard.vue';

export default {
  components: {
    HotelCategory,
    BannerNewsletter,
    TripadvisorScore,
    HotelCard,
    HotelConfirmationCard
  },
  filters: {
    capitalize: function (value) {
      if (!value) return '';
      value = value.toString().toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  methods: {
    extraPrice(extra) {
      const { one_per_passenger, has_counter } = extra;
      let quantity;

      if (one_per_passenger) {
        quantity = this.reservation.adultsQuantity;
      } else {
        quantity = has_counter ? extra.pivot.quantity : 1;
      }

      const price = (extra.pivot.price || extra.price) * quantity;
      return round(price);
    },
  },
  computed: {
    ...mapGetters({
      passengersCount: NIGHTS_GET_PASSENGERS_COUNT,
      finalPrice: GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT,
      reservation: GET_RESERVATION,
    }),
    destination() {
      return this.reservation.destinationName;
    },
    flight() {
      return this.$store.state.nights.flight;
    },
    hotel() {
      let clone = {
        ...this.reservation.hotel,
        categoryCode: this.reservation.hotel?.category
      }
      return clone || null;
    },
    packContact() {
      return this.$store.state.nights;
    },
    extras() {
      return this.reservation.extras || null;
    },
    bags() {
      return this.reservation.bags;
    },
    adults(){
      return this.reservation.adultsQuantity;
    },
    nights() {
      const start = this.reservation.outboundTrip.departure.datetime;
      const end = this.reservation.inboundTrip.departure.datetime;
      if (!start || !end) return 0;
      return end.diff(start, "days");
    },
    redsysParams() {
      return (
        (this.$route.query.redsys && JSON.parse(this.$route.query.redsys)) ||
        null
      );
    },
    rooms(){
      let arr = [];
      this.hotel.rooms.forEach(room => {
        arr.push(room);
      });
      return arr;
    },
    premium_insurance() {
      return this.reservation.payload.premium_insurance;
    },
    extra_hotel_luxury() {
      return this.reservation.payload.extra_hotel_luxury;
    },
    premium_insurance_price() {
      return this.reservation.payload.premium_insurance_price;
    }
  },
};
</script>

<style lang="scss" scoped>
.confirm-container {
  margin-top: 0;
   @media(max-width:768px) {
      margin-top: 40px;
    }
}
.nights-comfirmation {
  background-color: white;
  max-width: 900px;
  margin: 0 auto;
  min-height: 100vh;
  .sumary-title {
    text-align: center;
    font-weight: bold;
    padding: 3rem;
    h1 {
      font-size: 45px;
    }
    @media(max-width:768px) {
      padding: 0 20px 20px 20px;
    }
  }
  .img-confirmation {
    height:210px;
  }
  .confim-card {
    border-radius: 15px;
    border: solid 0.5px #9b9b9b;


    &-body {
      padding: 1.25rem 1.25rem .75rem;
      @media (min-width: 768px) {
        display: flex;
        flex-direction: row;
        padding: 1.25rem;
      }
      .hotel-name {
        @media (min-width: 1024px) {
          font-size: 20px;
        }
      }
      .hotel-category-component {
        display: flex;
      }
      .hotel-image {
        width: 129px;
        height: 104px;
        object-fit: cover;
        margin-bottom: 1.25rem;
        @media (min-width: 768px) {
          margin-bottom: 0;
        }
      }

      .num-rooms{
        padding: .15rem 0;
      }

    }
  }
  .detail-box {
    min-height: 220px;
     @media (max-width: 768px) {
          min-height: auto;
      }
      &-2 {
        margin-top: 0;
      }
      @media (max-width: 768px) {
        margin-top: 20px;
      }
  }
  .travel-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    max-width: 22rem;

    + .travel-container {
      margin-top: 2rem;
      @media (min-width: 768px) {
        margin-left: 3rem;
        margin-top: 0;
      }
    }

    h3 {
      margin-bottom: 1rem;
    }
    .origin-destiny {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      .dotted-line {
        border-top: 1px dotted #979797;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-self: center;
        margin: 0 0.5rem;
      }
      p {
        width: max-content;
      }
      .origin,
      .destiny {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
}
</style>
